<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <!-- <div class="col-lg-6 col-5">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ certificate_name }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            {{ course_name }}
          </nav>
        </div> -->
        <h3 class="text-white d-inline-block mb-0"></h3>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" footer-classes="pt-1">
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-md-4 text-left">
                <h2 class="mb-0">{{ certificate }} Certificate</h2>
              </div>
              <div class="col-lg-8 col-12 text-right certificate-btn">
                <base-button class="custom-btn" name="Certificate Reset Filters" v-on:click="resetFilters()"><i
                    class="fa fa-refresh" aria-hidden="true"></i> Clear
                  Filters</base-button>
                <div class="d-inline-block">
                  <!-- <JsonExcel
                    :data="json_data"
                    header="applcation/vnd.ms-excel"
                    :exportFields="json_fields"
                    :name="course_name + ' Certificates.xls'"
                  >
                    <base-button class="custom-btn" style="margin-top:5px;">
                      Export Certificate Data
                    </base-button>
                  </JsonExcel> -->
                  <el-tooltip content="View Certificates" placement="top">
                    <base-button name="View Certificate" @click="viewCertificates" class="custom-btn"
                      data-toggle="tooltip" data-original-title="View Certificates">
                      View Certificates
                    </base-button>
                  </el-tooltip>
                  <!-- <a
                    :href="
                      baseUrl +
                        '/employee/certificate_manual/saved_pdf/result.pdf'
                    "
                    target="_blank"
                    @click="viewCertificates"
                  >
                    View Certificates</a
                  > -->
                  <el-tooltip content="Export Certificate Data" placement="top">
                    <base-button name="Export Certificate Data" @click="downloadExcel" class="custom-btn"
                      data-toggle="tooltip" data-original-title="Export Certificate Data">
                      Export Certificate Data
                    </base-button>
                  </el-tooltip>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <!-- <a
                  :href="
                    baseUrl +
                      '/downloadAllCourseCertificate/' +
                      employeeUrl.join('_') +
                      '/' +
                      courseUrl.join('_')
                  "
                  class="custom-btn"
                  data-toggle="tooltip"
                  data-original-title="Download"
                  target="_blank"
                >
                  <span> Download Certificates</span></a
                > -->
              </div>
            </div>
          </template>
          <div>
            <div class="d-flex flex-wrap align-items-end mb-2" style="gap: 15px;">
              <div style="flex: 1; min-width: 180px;">
                <base-input
                  label="Search:"
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                />
              </div>
              <div style="flex: 1; min-width: 180px;">
                <base-input label="Parent Company:">
                  <el-select
                    filterable
                    name="Certificate Screen Parent Company filter"
                    class="select-primary"
                    v-on:change="onParentCompanyChange"
                    v-model="filters.parent_company_id"
                    placeholder="Filter by Parent Company"
                    style="width:100%"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in parentCompanies"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </base-input>
              </div>
              <div style="flex: 1; min-width: 180px;" v-if="filters.parent_company_id">
                <base-input label="Location:">
                  <el-select
                    filterable
                    name="Certificate Screen Location filter"
                    class="select-primary"
                    v-on:change="fetchData()"
                    v-model="filters.location_id"
                    placeholder="Filter by Location"
                    style="width:100%"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in locations"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </base-input>
              </div>
              <div style="flex: 1; min-width: 180px;">
                <base-input label="Status:">
                  <el-select
                    class="select-primary"
                    v-on:change="fetchData()"
                    v-model="filters.certificateStatus"
                    placeholder="Filter by Certificate Status"
                    style="width:100%"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </base-input>
              </div>
              <div style="flex: 1; min-width: 180px;">
                <base-input label="Date Range:">
                  <el-date-picker
                    v-model="filters.date_range"
                    @change="fetchData()"
                    type="daterange"
                    unlink-panels
                    value-format="MM/dd/yyyy"
                    format="MM/dd/yyyy"
                    range-separator="-"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    style="width: 100%"
                  />
                </base-input>
              </div>
              <div style="flex: 1; min-width: 180px;">
                <base-input label="User Status:">
                  <el-select
                    class="select-primary"
                    v-on:change="fetchData()"
                    v-model="filters.userStatus"
                    placeholder="Filter by User Status"
                    style="width:100%"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in userStatusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </base-input>
              </div>
            </div>
            <div class="user-eltable table-wrapper">
              <el-table :data="tableData" class="certGrid" role="table" row-key="id"
                :row-class-name="tableRowClassName"
                header-row-class-name="thead-light custom-thead-light" @selection-change="selectionChange">
                <el-table-column min-width="130px" label="">
                  <template slot="header">
                    <span @click="sortByColumn(0)" style="cursor: pointer;">First Name
                      <i v-if="sortedColumn == 0 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" />
                      <i v-else-if="sortedColumn == 0 && order === 'desc'" class="fas fa-arrow-down text-blue linkColor" />
                      <i v-else class="fas fa-sort text-muted" style="opacity: 0.5;"></i>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <router-link :to="`add_employee?id=${props.row.employee_id}`">
                      <span>{{ props.row.first_name }}</span>
                    </router-link>
                  </template>
                </el-table-column>

                <el-table-column min-width="130px" label="">
                  <template slot="header">
                    <span @click="sortByColumn(1)" style="cursor: pointer;">Last Name
                      <i v-if="sortedColumn == 1 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" />
                      <i v-else-if="sortedColumn == 1 && order === 'desc'" class="fas fa-arrow-down text-blue linkColor" />
                      <i v-else class="fas fa-sort text-muted" style="opacity: 0.5;"></i>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.last_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="120px" label="">
                  <template slot="header">
                    <span @click="sortByColumn(2)" style="cursor: pointer;">Completion Date
                      <i v-if="sortedColumn == 2 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" />
                      <i v-else-if="sortedColumn == 2 && order === 'desc'" class="fas fa-arrow-down text-blue linkColor" />
                      <i v-else class="fas fa-sort text-muted" style="opacity: 0.5;"></i>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ formattedDate(props.row.certificate_date) }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="120px" label="">
                  <template slot="header">
                    <span @click="sortByColumn(3)" style="cursor: pointer;">Expiration Date
                      <i v-if="sortedColumn == 3 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" />
                      <i v-else-if="sortedColumn == 3 && order === 'desc'" class="fas fa-arrow-down text-blue linkColor" />
                      <i v-else class="fas fa-sort text-muted" style="opacity: 0.5;"></i>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ formattedDate(props.row.expiration_date) }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="120px" label="Location">
                  <template slot="header">
                    <span @click="sortByColumn(4)" style="cursor: pointer;">Location
                      <i v-if="sortedColumn == 4 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" />
                      <i v-else-if="sortedColumn == 4 && order === 'desc'" class="fas fa-arrow-down text-blue linkColor" />
                      <i v-else class="fas fa-sort text-muted" style="opacity: 0.5;"></i>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.location }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="100px" label="Status">
                  <template slot-scope="props">
                    <span v-if="isActive(props.row)">Active</span>
                    <span v-else>Expired</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="135px" label="Course">
                  <template slot="header">
                    <span @click="sortByColumn(5)" style="cursor: pointer;">Course
                      <i v-if="sortedColumn == 5 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" />
                      <i v-else-if="sortedColumn == 5 && order === 'desc'" class="fas fa-arrow-down text-blue linkColor" />
                      <i v-else class="fas fa-sort text-muted" style="opacity: 0.5;"></i>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.course_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="135px" label="Course">
                  <template slot="header">Certificate Number</template>
                  <template slot-scope="props">
                    <span :title="props.row.is_platform_generated ? 'Platform-generated number - assign a real certificate number' : ''">
                      #{{ props.row.certificate_no }}
                      <i v-if="props.row.is_platform_generated" class="fas fa-exclamation-triangle text-warning"></i>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column min-width="170px" class-name="td-actions" label="Action">
                  <template slot-scope="props">
                    <div class="action-icons-container">
                      <el-tooltip content="Edit Certificate Number" placement="top" v-if="editor == 'super-admin'">
                        <span @click="editCertificateNumber(props.row)" data-toggle="tooltip" class="action-icon">
                          <i class="fas fa-edit"></i>
                        </span>
                      </el-tooltip>
                      <el-tooltip content="Preview" placement="top" v-if="props.row.is_proctored_exam == 1">
                        <a @click.prevent="
                          getProctoredExamCertificate(
                            props.row.certificate_url
                          )
                          " data-original-title="Preview" data-toggle="tooltip" class="action-icon">
                          <span>
                            <i name="Preview Proctored Exam Certificate" class="text-success fa fa-eye"
                              v-if="!props.row.show_loader"></i>
                            <i class="text-success fas fa-spin fa-spinner" v-if="props.row.show_loader"></i>
                          </span>
                        </a>
                      </el-tooltip>
                      <el-tooltip content="Preview" placement="top" v-else>
                        <a :href="baseUrl +
                          '/downloadCourseCertificate/preview/' +
                          props.row.course_id +
                          '/' +
                          props.row.employee_id +
                          '/' +
                          props.row.certificate_id
                          " data-toggle="tooltip" data-original-title="Preview" target="_blank" class="action-icon">
                          <span>
                            <i name="Preview Certificate" class="text-success fa fa-eye"></i>
                          </span>
                        </a>
                      </el-tooltip>
                      <el-tooltip content="Download" placement="top" v-if="props.row.is_proctored_exam == 0">
                        <a :href="baseUrl +
                          '/downloadCourseCertificate/download/' +
                          props.row.course_id +
                          '/' +
                          props.row.employee_id +
                          '/' +
                          props.row.certificate_id
                          " data-toggle="tooltip" data-original-title="Download" target="_blank" class="action-icon">
                          <span>
                            <i class="text-warning fa fa-download"></i>
                          </span>
                        </a>
                      </el-tooltip>
                      <el-tooltip content="Approve" placement="top" v-if="(props.row.is_certificate_approved == 0) && (editor == 'super-admin')">
                        <span @click="approveCertificate(props.row)" data-toggle="tooltip"
                          data-original-title="Approve" class="action-icon">
                          <i class="text-success fa fa-check"></i>
                        </span>
                      </el-tooltip>
                      <el-tooltip content="Email Certificate" placement="top" v-if="props.row.is_certificate_approved == 1">
                        <span @click="emailCertificate(props.row)" data-toggle="tooltip"
                          data-original-title="Email Certificate" class="action-icon">
                          <i class="text-success fa fa-envelope"></i>
                        </span>
                      </el-tooltip>
                      <el-tooltip content="Download" placement="top" v-if="props.row.is_certificate_approved == 1">
                        <a :href="baseUrl + '/downloadCourseCertificate/download/' + props.row.course_id + '/' + props.row.employee_id + '/' + props.row.certificate_id"
                          data-toggle="tooltip" data-original-title="Download" target="_blank" class="action-icon">
                          <i class="text-warning fa fa-download"></i>
                        </a>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div slot="footer" class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            ">
            <div class="">
              <!-- <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p> -->
            </div>
            <div slot="footer" class="d-flex justify-content-between align-items-center">
              <div></div>
              <nav v-if="pagination && tableData.length > 0">
                <div class="row">
                  <div class="col-md-12">
                    <ul class="pagination custompagination justify-content-end align-items-center">
                      <p class="p-0 m-0 mr-2 d-flex align-items-center">
                        <span class="mr-1">Showing</span>
                        <el-select
                          class="select-primary pagination-select mx-1"
                          v-model="perPage"
                          @change="changePage(1)"
                          placeholder="Per page"
                          size="mini"
                          style="width: auto; display: inline-block;"
                        >
                          <el-option
                            class="select-primary"
                            v-for="item in perPageOptions"
                            :key="item"
                            :label="item"
                            :value="item"
                          />
                        </el-select>
                        <span class="ml-1">of {{ totalData }} entries</span>
                      </p>
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                          <i class="fa fa-caret-left"></i>
                        </a>
                      </li>
                      <li
                        v-for="(page, index) in pagesNumber"
                        :key="index"
                        class="page-item"
                        :class="{ active: page === currentPage }"
                      >
                        <a href="javascript:void(0)" @click.prevent="changePage(page)" class="page-link">
                          {{ page }}
                        </a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === last_page }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                          <i class="fa fa-caret-right"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="download_certificate">
      <h6 class="title title-up">Download all the certificates</h6>
      <a download :href="download_file_link" class="btn btn-success">Download</a>
    </modal>
        <modal :show.sync="isCertificateEdit">
      <h4 slot="header" style="color:#444C57" class="title title-up text-center">Edit Certificate Number</h4>
      <div class="row">
        <div class="col-12 mb-3">
          <label class="d-block"><strong>Employee Name:</strong></label>
          <span class="fw-bold">{{ selectedCertificate.first_name }}</span>
        </div>
        <div class="col-12 mb-3">
          <label class="d-block"><strong>Course Name:</strong></label>
          <span class="fw-bold">{{ selectedCertificate.course_name }}</span>
        </div>
        <div class="col-12 mb-3">
          <label class="d-block"><strong>Current Certificate Number:</strong></label>
          <span class="fw-bold">{{ selectedCertificate.certificate_no !== "" ? selectedCertificate.certificate_no : 0 }}</span>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label><strong>New Certificate Number</strong></label>
            <input type="text" v-model="new_certificate_number" class="form-control" />
          </div>
        </div>
        <div class="col-12 mb-3">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="cascadeFixCheckbox" v-model="cascade_fix" />
            <label class="form-check-label" for="cascadeFixCheckbox">
              <strong>Also fix following certificates in sequence</strong>
            </label>
          </div>
          <small class="text-muted">Renumbers the certificates issued after this one (+1, +2, ...) and stops automatically where the series is already correct. You will see a preview before anything is changed.</small>
        </div>
        <div class="col-12 text-right">
          <base-button class="custom-btn" @click="updateCertificateNumber">Update</base-button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import { BasePagination } from "@/components";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
//import swal from 'sweetalert';
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import XLSX from "xlsx";
import moment from "moment";
let timeout = null;
export default {
  mixins: [serverSidePaginationMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      new_certificate_number: "",
      cascade_fix: false,
      selectedCertificate: {},
      isCertificateEdit: false,
      loading: false,
      baseUrl: this.$baseUrl,
      download_certificate: false,
      download_file_link: "",
      isLoading: false,
      fullPage: true,
      company_id: "",
      hot_user: "",
      hot_token: "",
      config: "",
      searchQuery: "",
      course_id: "",
      tbl_data: [],
      course_name: "",
      resultGenerated: false,
      json_fields: {
        "Employee First Name": "First Name",
        "Employee Last Name": "Last Name",
        "Course Name": "Course Name",
        "Certificate Name": "Certificate Name",
        "Certificate Date": "Certificate Date",
        "Certificate Expiry Date": "Certificate Expiry Date",
      },

      json_data: [],
      locationManager: false,
      location_id: "",
      certificate_name: "",
      status: [
        {
          label: "Active Certificates",
          value: "Active Certificates",
        },
        {
          label: "Expired Certificates",
          value: "Expired Certificates",
        },
        {
          label: "Show All",
          value: "",
        },
      ],
      userStatusOptions: [
        {
          label: "Active",
          value: "1",
        },
        {
          label: "Inactive",
          value: "0",
        },
        {
          label: "All",
          value: "2",
        },
      ],
      parentCompanies: [
        {
          label: "All",
          value: "",
        },
      ],
      locations: [
        {
          label: "All",
          value: "",
          parent_id: 0,
        },
      ],
      filters: {
        certificateStatus: "Active Certificates",
        parent_company_id: "",
        location_id: "",
        date_range: null,
        userStatus: "1", // Default to Active users
      },
      editor: "",
      interface: "",
      tableData: [],
      selectedRows: [],
      employeeUrl: [],
      courseUrl: [],
      certificate: "",
      course_ids: [],
      certificate_ids: [],
      employee_ids: [],
      highestPageWithData: 0, // Track the highest page we've successfully loaded data from
    };
  },
  computed: {
    paginationFrom() {
      if (this.totalData === 0 || this.tableData.length === 0) return 0;
      const from = (this.currentPage - 1) * this.perPage + 1;
      return Math.max(1, from);
    },
    paginationTo() {
      if (this.totalData === 0 || this.tableData.length === 0) return 0;
      const calculatedTo = this.currentPage * this.perPage;
      const actualTo = Math.min(calculatedTo, this.totalData);
      // Ensure we don't show more than what we actually have
      const actualDataCount = (this.currentPage - 1) * this.perPage + this.tableData.length;
      return Math.min(actualTo, actualDataCount);
    }
  },
  watch: {
    searchQuery: function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    },
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "admin";
      this.company_id = localStorage.getItem("hot-user-id");
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.editor = "manager";
    }

    if (this.$route.query.id) {
      this.certificate_id = this.$route.query.id;
    }
    if (this.$route.query.course) {
      this.course_id = this.$route.query.course;
    }
    if (this.$route.query.certificate) {
      this.certificate = this.$route.query.certificate;
    }
    // this.fetchData();
    this.setDefaultFilterData();
    this.fetchParentCompanies();
  },
  methods: {
    fetchParentCompanies() {
      this.$http
        .post("location/all_company_location", {
          role: this.editor,
          onlyParent: true,
        })
        .then((resp) => {
          this.parentCompanies = [
            {
              label: "All",
              value: "",
            },
          ];
          for (let company of resp.data) {
            let obj = {
              label: company.name,
              value: company.id,
            };
            this.parentCompanies.push(obj);
          }
        });
      
      // If no parent company is selected, load all locations
      if (!this.filters.parent_company_id) {
        this.fetchLocations();
      }
    },
    fetchLocations(companyId = null) {
      const requestData = {
        role: this.editor,
      };
      
      if (companyId) {
        requestData.company_id = companyId;
      }
      
      this.$http
        .post("location/all_company_location", requestData)
        .then((resp) => {
          this.locations = [
            {
              label: "All",
              value: "",
            },
          ];
          for (let loc of resp.data) {
            // If parent company is selected, only show child locations (where parent_id matches)
            if (companyId) {
              if (loc.parent_id == companyId || loc.id == companyId) {
                let obj = {
                  label: loc.name,
                  value: loc.id,
                  parent_id: loc.parent_id,
                };
                this.locations.push(obj);
              }
            } else {
              // If no parent company selected, show all locations
              let obj = {
                label: loc.name,
                value: loc.id,
                parent_id: loc.parent_id,
              };
              this.locations.push(obj);
            }
          }
        });
    },
    onParentCompanyChange() {
      // Reset location filter when parent company changes
      this.filters.location_id = "";
      
      if (this.filters.parent_company_id) {
        // Fetch locations for the selected parent company
        this.fetchLocations(this.filters.parent_company_id);
      } else {
        // If no parent company selected, load all locations
        this.fetchLocations();
      }
      
      // Fetch data with new filter
      this.fetchData();
    },
    editCertificateNumber(row){
      this.selectedCertificate = row;
      this.new_certificate_number = "";
      this.cascade_fix = false;
      this.isCertificateEdit = true;
    },
    tableRowClassName({ row }) {
      return row.is_platform_generated ? "platform-generated-row" : "";
    },
    certificateErrorMessage(error) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message;
      }
      return "Something went wrong.";
    },
    updateCertificateNumber(){
      if(this.new_certificate_number == ""){
        return Swal.fire({
          title: `Error`,
          html: `Please enter certificate number.`,
          icon: "error",
          confirmButtonClass: "btn btn-success",
        });
      }
      if (this.cascade_fix) {
        // Preview first, then confirm before applying
        this.$http.post('course/updateCertificateNumber',{
          employee_certifcate_id : this.selectedCertificate.employee_certifcate_id,
          new_certificate_no: this.new_certificate_number,
          cascade: true,
          preview: true
        }).then((res)=>{
          const changes = res.data.changes || [];
          const rows = changes.map(c =>
            `<tr><td style="text-align:left;padding:2px 8px;">${c.employee_name}</td>` +
            `<td style="padding:2px 8px;">${c.old_certificate_no || '-'}</td>` +
            `<td style="padding:2px 8px;">${c.new_certificate_no}</td></tr>`
          ).join("");
          Swal.fire({
            title: `Confirm ${changes.length} change${changes.length > 1 ? 's' : ''}`,
            html: `<div style="max-height:300px;overflow-y:auto;"><table style="width:100%;font-size:13px;">` +
              `<tr><th style="text-align:left;padding:2px 8px;">Employee</th><th>Current #</th><th>New #</th></tr>` +
              rows + `</table></div>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Apply changes",
            confirmButtonClass: "btn btn-success",
          }).then((result) => {
            if (result.value) {
              this.applyCertificateNumberUpdate(true);
            }
          });
        }).catch((error)=>{
          Swal.fire({
            title: `Error`,
            html: this.certificateErrorMessage(error),
            icon: "error",
            confirmButtonClass: "btn btn-success",
          });
        });
      } else {
        this.applyCertificateNumberUpdate(false);
      }
    },
    applyCertificateNumberUpdate(cascade){
      this.$http.post('course/updateCertificateNumber',{
        employee_certifcate_id : this.selectedCertificate.employee_certifcate_id,
        new_certificate_no: this.new_certificate_number,
        cascade: cascade
      }).then((res)=>{
        if(res.data.status == 1){
          const total = res.data.total || 1;
          Swal.fire({
            title: `Success`,
            html: total > 1 ? `${total} certificate numbers updated successfully.` : `Certificate number updated successfully.`,
            icon: "success",
            confirmButtonClass: "btn btn-success",
          });
          this.isCertificateEdit = false;
          this.fetchData();
        }else{
          Swal.fire({
            title: `Error`,
            html: `Something went wrong.`,
            icon: "error",
            confirmButtonClass: "btn btn-success",
          });
        }
      }).catch((error)=>{
        Swal.fire({
          title: `Error`,
          html: this.certificateErrorMessage(error),
          icon: "error",
          confirmButtonClass: "btn btn-success",
        });
      });
    },
    isActive(row) {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = yyyy + "-" + mm + "-" + dd;
      if (row.expiration_date >= today) {
        return true;
      }
    },
    formattedDate(data) {
      return moment(data).format("MM-DD-YYYY");
    },
    /** Same filters as the grid; omit page/per_page to fetch all rows (export). */
    passEmployeeBaseRequest() {
      let companyId = "";
      if (this.filters.location_id) {
        companyId = this.filters.location_id;
      } else if (this.filters.parent_company_id) {
        companyId = this.filters.parent_company_id;
      }
      let dateRange = null;
      if (this.filters.date_range && this.filters.date_range.length === 2) {
        dateRange = {
          start: this.filters.date_range[0],
          end: this.filters.date_range[1],
        };
      }
      return {
        search: this.searchQuery,
        certificate_status: this.filters.certificateStatus,
        course_id: this.course_id,
        certificate_id: this.certificate_id,
        interface: "Employee",
        company_id: companyId,
        date_range: dateRange,
        user_status: this.filters.userStatus,
        column: this.sortedColumn,
        order: this.order,
      };
    },
    fetchData() {
      this.loading = true;
      let self = this;
      
      this.$http
        .post("course/pass_employee", {
          ...this.passEmployeeBaseRequest(),
          page: this.currentPage,
          per_page: this.perPage
        })
        .then((resp) => {
          // Validate response structure
          if (!resp || !resp.data) {
            console.error('Invalid API response:', resp);
            this.totalData = 0;
            this.tableData = [];
            return;
          }

          let employee_data = resp.data.employee || [];
          
          // Robust total calculation with fallbacks
          let total = resp.data.total;
          
          // Validate and parse total
          if (total === undefined || total === null || total === '' || isNaN(total)) {
            // Fallback: use array length if total is missing
            total = employee_data.length;
            console.warn('Total count missing from API, using fallback:', total);
          } else {
            total = parseInt(total, 10);
            if (isNaN(total) || total < 0) {
              total = employee_data.length;
              console.warn('Invalid total count from API, using fallback:', total);
            }
          }
          
          // Ensure totalData is always a valid number
          this.totalData = Math.max(0, total);
          
          // Track the highest page we've successfully loaded data from
          if (employee_data.length > 0) {
            this.highestPageWithData = Math.max(this.highestPageWithData, this.currentPage);
          }
          
          // Calculate minimum total based on pages we've seen
          const minTotalFromPages = this.highestPageWithData * this.perPage;
          
          // If we got a full page of results, there's definitely more data
          // This is the key detection: full page = more data exists
          if (employee_data.length === this.perPage) {
            // We got a full page, so there's at least one more item (likely a full next page)
            const estimatedMinTotal = this.currentPage * this.perPage + 1;
            // Always update if we got a full page and backend says less
            if (this.totalData < estimatedMinTotal) {
              console.warn(`Backend reported total (${this.totalData}) is incorrect. Got full page (${this.perPage} items on page ${this.currentPage}). Updating to minimum: ${estimatedMinTotal}`);
              this.totalData = estimatedMinTotal;
            }
          }
          
          // If we're on a later page and got items, ensure total is at least enough to show this page
          if (employee_data.length > 0 && this.currentPage > 1) {
            const minTotal = (this.currentPage - 1) * this.perPage + employee_data.length;
            if (this.totalData < minTotal) {
              console.warn(`Updating total from ${this.totalData} to ${minTotal} based on current page data`);
              this.totalData = minTotal;
            }
          }
          
          // If we got more items than the reported total on first page, update it
          if (employee_data.length > 0 && this.currentPage === 1 && this.totalData < employee_data.length) {
            console.warn(`Updating total from ${this.totalData} to ${employee_data.length} based on actual data count`);
            this.totalData = employee_data.length;
          }
          
          // Use the highest page we've seen to calculate minimum total
          if (this.highestPageWithData > 0 && this.totalData < minTotalFromPages) {
            console.warn(`Updating total from ${this.totalData} to ${minTotalFromPages} based on highest page seen (${this.highestPageWithData})`);
            this.totalData = minTotalFromPages;
          }
          
          // Final validation: ensure total is never less than items we've seen on current page
          const itemsSeenOnCurrentPage = (this.currentPage - 1) * this.perPage + employee_data.length;
          if (this.totalData < itemsSeenOnCurrentPage) {
            console.warn(`Final adjustment: updating total from ${this.totalData} to ${itemsSeenOnCurrentPage} to match items seen on current page`);
            this.totalData = itemsSeenOnCurrentPage;
          }
          
          // If we got a full page, always ensure total allows for at least one more page
          if (employee_data.length === this.perPage) {
            const absoluteMin = this.currentPage * this.perPage + 1;
            if (this.totalData < absoluteMin) {
              this.totalData = absoluteMin;
            }
          }
          
          this.tableData = [];
          this.employeeUrl = [];
          this.courseUrl = [];
          this.json_data = [];
          for (let data of employee_data) {
            let obj = [];

            obj = {
              certificate_id: data.employee_certifcate_id,
              employee_id: data.employee_id,
              course_id: data.course_id,
              course_name: data.course_name,
              first_name: data.first_name,
              last_name: data.last_name,
              location: data.company_name,
              certificate_date: data.employee_course_date_completed,
              expiration_date: data.certificate_expiration_date,
              is_proctored_exam: data.is_proctored_exam,
              certificate_url: data.certificate_url,
              show_loader: false,
              is_certificate_approved: data.is_certificate_approved,
              certificate_no: data.certificate_no,
              is_platform_generated: data.is_platform_generated,
              employee_certifcate_id : data.employee_certifcate_id,

            };
            this.employeeUrl.push(obj.employee_id);
            this.courseUrl.push(obj.course_id);
            this.tableData.push(obj);
            this.course_name = obj.course_name;
            let row = {
              "First Name": data.first_name,
              "Last Name": data.last_name,
              "Course Name": data.course_name,
              "Certificate Name": data.certificate_name,
              "Certificate Date": data.employee_course_date_completed,
              "Certificate Expiry Date": data.certificate_expiration_date,
            };

            this.json_data.push(row);
          }
        })
        .catch((error) => {
          console.error('Error fetching certificate data:', error);
          this.totalData = 0;
          this.tableData = [];
          if (error.response && error.response.status === 422) {
            Swal.fire({
              title: 'Error',
              html: error.response.data?.message || 'Failed to load certificate data. Please try again.',
              icon: 'error',
              confirmButtonClass: 'btn btn-success',
            });
          }
        })
        .finally(() => (this.loading = false));
      this.saveSearchData();
    },
    saveSearchData() {
      localStorage.setItem(
        "all_certificate_detail_search_data",
        JSON.stringify({
          search: this.searchQuery,
          certificate_status: this.filters.certificateStatus,
          course_id: this.course_id,
          certificate_id: this.certificate_id,
          parent_company_id: this.filters.parent_company_id,
          company_id: this.filters.location_id,
          date_range: this.filters.date_range,
          user_status: this.filters.userStatus,
          column: this.sortedColumn,
          order: this.order,
        })
      );
    },
    setDefaultFilterData() {
      let previousStateData = JSON.parse(
        localStorage.getItem("all_certificate_detail_search_data")
      );

      if (previousStateData !== null) {
        this.searchQuery = previousStateData.search
          ? previousStateData.search
          : this.searchQuery;
        this.filters.certificateStatus = previousStateData.certificate_status
          ? previousStateData.certificate_status
          : this.filters.certificateStatus;
        this.course_id = this.$route.query.course
          ? this.$route.query.course
          : previousStateData.course_id
            ? previousStateData.course_id
            : this.course_id;
        this.certificate_id = this.$route.query.id
          ? this.$route.query.id
          : previousStateData.certificate_id
            ? previousStateData.certificate_id
            : this.certificate_id;
        this.filters.parent_company_id = previousStateData.parent_company_id
          ? previousStateData.parent_company_id
          : "";
        this.filters.location_id = previousStateData.company_id
          ? previousStateData.company_id
          : "";
        this.filters.date_range = previousStateData.date_range
          ? previousStateData.date_range
          : null;
        this.filters.userStatus = previousStateData.user_status
          ? previousStateData.user_status
          : "1"; // Default to Active
        this.company_id = previousStateData.company_id
          ? previousStateData.company_id
          : this.company_id;
        this.sortedColumn = previousStateData.column !== undefined && previousStateData.column !== null
          ? previousStateData.column
          : 2; // Default to Completion Date (column 2)
        this.order = previousStateData.order
          ? previousStateData.order
          : 'desc'; // Default to descending (newest first)
        
        // Load locations based on parent company if set
        if (this.filters.parent_company_id) {
          this.fetchLocations(this.filters.parent_company_id);
        }
      } else {
        // No previous state - set default to sort by Completion Date descending
        this.sortedColumn = 2;
        this.order = 'desc';
      }
      this.fetchData();
    },
    resetFilters() {
      this.company_id = "";
      this.filters.certificateStatus = "Active Certificates";
      this.searchQuery = "";
      this.filters.parent_company_id = "";
      this.filters.location_id = "";
      this.filters.date_range = null;
      this.filters.userStatus = "1"; // Reset to Active users
      this.sortedColumn = 2; // Reset to Completion Date
      this.order = "desc"; // Newest first
      this.highestPageWithData = 0; // Reset page tracking
      this.fetchLocations(); // Reset to show all locations
      this.fetchData();
    },
    viewCertificates() {
      this.loading = true;
      this.certificate_ids = [];
      this.course_ids = [];
      this.employee_ids = [];
      for (let data of this.tableData) {
        this.course_ids.push(data.course_id);
        this.employee_ids.push(data.employee_id);
        this.certificate_ids.push(data.certificate_id);
      }

      this.$http
        .post("user/saveCertificatePdf", {
          course_id: this.course_ids,
          employee_id: this.employee_ids,
          certificate_id: this.certificate_ids,
        })
        .then((resp) => {
          this.resultGenerated = true;
          if (resp.data.user_not_merged) {
            Swal.fire({
              title: `Error`,
              html: "Due to security settings, the following certificates cannot be included in the mass download:</br>" +
                resp.data.user_not_merged +
                "</br> Please download the above user certificates individually.",
              icon: "error",
            }).then((result) => {
              if (result.value) {
                window.open(
                  this.$baseUrl +
                  "/employee/certificate_manual/saved_pdf/" +
                  resp.data.file_name,
                  "_blank"
                );
              }
            });
          } else {
            window.open(
              this.$baseUrl +
              "/employee/certificate_manual/saved_pdf/" +
              resp.data.file_name,
              "_blank"
            );
          }
          // console.log("apiCallled");
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status === 422) {
             Swal.fire({
              title: `Error`,
              html: `Due to security settings, these certificates cannot be included in the mass download.</br>
                    Please download these users certificates individually.`,
              icon: "error",
            });
          }
        }).finally(() => (this.loading = false));;
    },

    downloadExcel() {
      this.$http
        .post("course/pass_employee", {
          ...this.passEmployeeBaseRequest(),
        })
        .then((resp) => {
          let employee_data = resp.data.employee;
          for (let data of employee_data) {
            let obj = [];
            obj = {
              course_name: data.course_name,
            };
          }
          //this.course_name = this.course_name;
          this.items = resp.data.download;
          const data1 = XLSX.utils.json_to_sheet(this.items);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data1, "data");
          XLSX.writeFile(wb, this.course_name + "Certificate.xlsx");
        })
        .finally(() => (this.loading = false));
    },
    printAllCertificates() {
      this.loading = true;
      this.$http
        .get("course/download_certificate/" + this.course_id)
        .then((resp) => {
          this.download_certificate = true;
          this.download_file_link = resp.data;
        })
        .finally(() => (this.loading = false));
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    getProctoredExamCertificate: function (certificateURL) {
      console.clear();
      console.log(certificateURL);
      let certificateIndex = null;
      this.tableData.forEach(function (certificate, index) {
        if (certificate.certificate_url == certificateURL) {
          certificateIndex = index;
          return true;
        }
      });
      this.tableData[certificateIndex].show_loader = true;
      this.$http
        .post("course/proctored-exam-certificate", {
          certificateURL: certificateURL,
        })
        .then((resp) => {
          this.tableData[certificateIndex].show_loader = false;
          window.open(resp.data.certificate_url, "_blank");
        });
    },
    approveCertificate: function (certificate) {
      this.$http.post("course/approve-certificate", {
        certificateId: certificate.certificate_id,
      }).then((resp) => {
        certificate.is_certificate_approved = 1;
      });
    },
    emailCertificate: function (certificate) {
      this.$http.post("course/email-certificate", certificate).then((resp) => {
        Swal.fire({
          title: resp.data.title,
          html: resp.data.message,
          icon: resp.data.icon
        });
      });
    }
  },
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}

@media only screen and (max-width: 760px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  .certGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "First Name";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Last Name";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Competion Date";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Expiration Date";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(5):before {
    content: "Status";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(6):before {
    content: "Course";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(7):before {
    content: "Actions";
  }

  /* Vertically center content in table cells on mobile */
  .certGrid>>>table.el-table__body td,
  .certGrid>>>table.el-table__header th {
    vertical-align: middle !important;
  }

  .certGrid>>>table.el-table__body td .cell,
  .certGrid>>>table.el-table__header th .cell {
    display: flex;
    align-items: center;
    min-height: 48px;
    vertical-align: middle;
  }

  .certGrid>>>table.el-table__body td .cell > *,
  .certGrid>>>table.el-table__header th .cell > * {
    display: flex;
    align-items: center;
  }

  /* Ensure inline elements are also vertically centered */
  .certGrid>>>table.el-table__body td .cell span,
  .certGrid>>>table.el-table__body td .cell a,
  .certGrid>>>table.el-table__body td .cell router-link {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
  }

  .certGrid>>>table.el-table__body td .action-icons-container {
    justify-content: flex-start;
    width: 100%;
  }
}

.action-icons-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
  white-space: nowrap;
}

.action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
  min-width: 20px;
  text-align: center;
}

.action-icon:hover {
  opacity: 0.7;
}

.action-icon i {
  font-size: 16px;
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

/* No width: max-content here - that forced the table wider than its
   container, so the wrapper always showed a horizontal scrollbar and the
   Action column was clipped at the edge. el-table honours each column's
   min-width and adds its own scrollbar only when the viewport is genuinely
   too narrow. */
.table-wrapper .certGrid {
  min-width: 100%;
}

.pagination-select {
  display: inline-block !important;
  width: auto !important;
}

.pagination-select >>> .el-input {
  width: auto !important;
}

.pagination-select >>> .el-input__inner {
  width: auto !important;
  padding: 0 20px 0 6px !important;
  height: 28px !important;
  line-height: 28px !important;
  font-size: 13px !important;
  min-width: auto !important;
}

.pagination-select >>> .el-input__suffix {
  right: 5px;
}

/* Certificates issued with a platform-generated number (pool was exhausted)
   stay highlighted until a real certificate number is assigned */
.certGrid >>> .el-table__row.platform-generated-row,
.certGrid >>> .el-table__row.platform-generated-row td {
  background-color: #fff3cd !important;
}

.certGrid >>> .el-table__row.platform-generated-row:hover td {
  background-color: #ffe9a8 !important;
}
</style>
